/**
 * Gender/blood-group option lists for the booking "register patient" step. Mirrored locally from the
 * patients feature (see PatientRegisterFields/patientView) rather than imported — scheduling and
 * patients are separate vertical slices and must not cross-import.
 */
export const GENDERS = ['Male', 'Female', 'Other'] as const;

export const BLOOD_GROUPS: ReadonlyArray<{ value: string; label: string }> = [
  { value: 'APos', label: 'A+' },
  { value: 'ANeg', label: 'A−' },
  { value: 'BPos', label: 'B+' },
  { value: 'BNeg', label: 'B−' },
  { value: 'AbPos', label: 'AB+' },
  { value: 'AbNeg', label: 'AB−' },
  { value: 'OPos', label: 'O+' },
  { value: 'ONeg', label: 'O−' },
];
